import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { useMyTeamRole } from '../../../team/useMyTeamRole';
import { usePlanStatus } from '../../hooks/usePlanStatus';
import { TrialStatusPill } from '../../trialStatus/TrialStatusPill';
import { accountMenuMessages as messages } from './accountMenuMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the account menu and sheet */
import styles from './AccountMenu.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface AccountMenuHeaderProps {
  email: string;
}

/**
 * design: navigation-v2 6a (nav2.css .amenu .who). The email, then the role and the plan. The
 * trial pill sits under them (it was in the sidebar bottom); it renders nothing without a trial.
 */
const AccountMenuHeaderComponent: React.FC<AccountMenuHeaderProps> = ({ email }) => {
  const intl = useIntl();
  const role = useMyTeamRole();
  const plan = usePlanStatus();

  return (
    <div className={styles.who}>
      <b className={styles.whoMail} title={email}>
        {email}
      </b>
      <small className={styles.whoLine} data-testid={`account-plan-${plan.variant}`}>
        {intl.formatMessage(messages.roleAndPlan, {
          role: intl.formatMessage(role === 'OWNER' ? messages.owner : messages.member),
          plan: plan.label,
        })}
      </small>
      <div className={styles.trial}>
        <TrialStatusPill />
      </div>
    </div>
  );
};

export const AccountMenuHeader = TypedMemo(AccountMenuHeaderComponent);
